import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAgreementsState } from '../../types/agreements';

export const initialAgreementsState: IAgreementsState = {
  marketingAgreement: false,
  personalData: true,
};

export const agreementsSlice = createSlice({
  name: 'agreements',
  initialState: initialAgreementsState,
  reducers: {
    setMarketingAgreement: (state, action: PayloadAction<boolean>) => {
      state.marketingAgreement = action.payload;
    },
    setPersonalData: (state, action: PayloadAction<boolean>) => {
      state.personalData = action.payload;
    },
  },
});

export const {
  reducer: agreementsReducer,
  actions: { setMarketingAgreement, setPersonalData },
} = agreementsSlice;
